export default {
    methods: {
        addUnit: function(){

            let _this = this;
            this.addingUnit = true;

            let elementFound = 0;

            this.guestOrderLines.forEach(function(element) {
                if(_this.order.product_id === element.product_id) {
                    element.pieces += 1;
                    elementFound = 1;
                }
            }, _this);

            if(elementFound) {
                this.order.pieces += 1;
                this.saveGuestShoppingCart();
            }
        },
        removeUnit: function(){

            let _this = this;
            this.addingUnit = true;

            let elementFound = 0;

            this.guestOrderLines.forEach(function(element) {
                if(_this.order.product_id === element.product_id) {
                    element.pieces -= 1;
                    elementFound = 1;
                }
            }, _this);

            if(elementFound) {
                this.order.pieces -= 1;
                this.saveGuestShoppingCart();
            }
        },

        deleteOrderLine: function(id) {
            let elementFound = 0;

            let index = this.guestOrderLines.forEach(function(element, index) {
                if(element.id === id) {
                    elementFound = 1;
                    return index;
                }
            }, id);

            if(elementFound) {
                this.guestOrderLines.splice(index, 1);
                this.removeOrderLine(id);
                window.decrementShoppingCart();
                this.saveGuestShoppingCart();
            }

            WinkelwagenEventBus.$emit("winkelwagen-remove-orderline", this.order);
        },
        changeOrderType: function(order, event, currentStatus) {

            event.preventDefault();

            if(order.order_offer === currentStatus) {
                return;
            }

            WinkelwagenEventBus.$emit("disable-radios");

            let _this = this;

            let elementFound = 0;

            this.guestOrderLines.forEach(function(element) {
                if(_this.order.product_id === element.product_id) {
                    element.order_offer = element.order_offer ? 0 : 1;
                    elementFound = 1;
                }
            }, _this);

            if(elementFound) {
                this.order.order_offer = this.order.order_offer ? 0 : 1;
                this.saveGuestShoppingCart();
            }

            WinkelwagenEventBus.$emit("enable-radios");

            return;
        },
        saveGuestShoppingCart: function() {
            localStorage.setItem('guestShoppingcart', JSON.stringify(this.guestOrderLines));
            $("#guestShoppingcart").val(localStorage.getItem('guestShoppingcart'));
        },
    },
    computed: {
        canSwitchOrderOffer: function() {
            return false;
        },
        guestOrderLines: function() {
            return JSON.parse(localStorage.getItem('guestShoppingcart'));
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/cart/helpers/product/guest.js